'use client';

import { AuthSessionContext } from '@/store/session';
import { usePathname } from 'next/navigation';
import { useContext, useEffect } from 'react';
import { publishPageEvent } from './publishEvent';

export const usePageEvent = (
  eventName: string,
  extraData?: Record<string, unknown>,
) => {
  const pathname = usePathname();
  const store = useContext(AuthSessionContext);

  useEffect(() => {
    if (store && pathname) {
      publishPageEvent(store.getState(), eventName, pathname, extraData);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, eventName]);
};
